const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.05 222.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M90.81,168.56c0-1.61-.11-3.2-.32-4.75l10.69-5.81c1.06-.58,1.57-1.81,1.24-2.97-.31-1.09-.67-2.17-1.05-3.23-.41-1.13-1.55-1.83-2.75-1.67l-12.05,1.59c-1.52-2.81-3.4-5.39-5.59-7.68l5.23-10.98c.52-1.1.19-2.4-.76-3.15-.88-.68-1.78-1.34-2.7-1.97-1.01-.68-2.35-.59-3.23.24l-8.82,8.36c-2.83-1.36-5.86-2.36-9.04-2.93l-2.22-11.95c-.22-1.18-1.22-2.05-2.42-2.09-.57-.02-1.14-.03-1.72-.03s-1.15.01-1.72.03c-1.2.04-2.2.92-2.42,2.09l-2.22,11.95c-3.18.57-6.21,1.57-9.04,2.93l-8.82-8.36c-.88-.84-2.22-.93-3.23-.24-.92.63-1.83,1.28-2.7,1.97-.96.75-1.29,2.05-.76,3.15l5.23,10.98c-2.19,2.29-4.07,4.87-5.59,7.68l-12.05-1.59c-1.19-.16-2.34.54-2.75,1.67-.39,1.06-.74,2.14-1.05,3.23-.33,1.16.18,2.39,1.24,2.97l10.69,5.81c-.21,1.55-.32,3.14-.32,4.75s.11,3.2.32,4.75l-10.69,5.81c-1.06.58-1.57,1.81-1.24,2.97.31,1.09.67,2.17,1.05,3.23.41,1.13,1.55,1.83,2.75,1.67l12.05-1.59c1.52,2.81,3.4,5.39,5.59,7.68l-5.23,10.98c-.52,1.1-.19,2.4.76,3.15.88.68,1.78,1.34,2.7,1.97,1.01.68,2.35.59,3.23-.24l8.81-8.36h.01c2.83,1.36,5.87,2.36,9.05,2.93l2.21,11.94c.22,1.18,1.22,2.05,2.42,2.1.57.02,1.14.03,1.72.03s1.15-.01,1.72-.03c1.2-.04,2.2-.92,2.42-2.1l2.21-11.94c3.18-.57,6.22-1.57,9.05-2.93h.01l8.81,8.36c.88.84,2.22.93,3.23.24.92-.63,1.83-1.28,2.7-1.97.96-.75,1.29-2.05.76-3.15l-5.23-10.98c2.19-2.29,4.07-4.87,5.59-7.68l12.05,1.59c1.19.16,2.34-.54,2.75-1.67.39-1.06.74-2.14,1.05-3.23.33-1.16-.18-2.39-1.24-2.97l-10.69-5.81c.21-1.55.32-3.14.32-4.75ZM57.36,188.66c-12.78,1.27-23.44-9.39-22.17-22.17.94-9.46,8.59-17.11,18.05-18.05,12.78-1.27,23.44,9.39,22.17,22.17-.94,9.46-8.59,17.11-18.05,18.05Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.65,161.56h-8c0-19.32-6.25-37.86-18.06-53.61-12.52-16.7-16.12-38.12-9.86-58.78,6.18-20.39,22.18-36.06,42.79-41.91,20.34-5.77,41.38-1.99,57.75,10.38,16.33,12.34,25.7,31.15,25.7,51.59,0,14.06-4.44,27.43-12.84,38.66-11.85,15.84-18.11,34.4-18.11,53.67h-8c0-21.02,6.81-41.24,19.7-58.47,7.36-9.84,11.25-21.55,11.25-33.86,0-17.92-8.21-34.39-22.52-45.21-14.34-10.84-32.83-14.14-50.74-9.06-17.98,5.1-31.93,18.76-37.32,36.53-5.51,18.19-2.38,37.02,8.6,51.66,12.86,17.15,19.66,37.35,19.66,58.41Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,209.69h-9.88c-15.85,0-28.75-12.89-28.75-28.75v-23.39h67.37v23.39c0,15.85-12.89,28.75-28.75,28.75ZM116.65,165.56v15.39c0,11.44,9.31,20.75,20.75,20.75h9.88c11.44,0,20.75-9.31,20.75-20.75v-15.39h-51.37Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.33,
    y: 151.07,
    width: 8,
    height: 59.85,
    transform: "translate(-55.23 299.26) rotate(-82.72)",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.33,112.45c-2.21,0-4-1.79-4-4v-59.9c0-2.21,1.79-4,4-4s4,1.79,4,4v59.9c0,2.21-1.79,4-4,4Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.25,112.45c-1.49,0-2.91-.83-3.6-2.26l-19.55-40.42c-.96-1.99-.13-4.38,1.86-5.34,1.99-.96,4.38-.13,5.34,1.86l19.55,40.42c.96,1.99.13,4.38-1.86,5.34-.56.27-1.15.4-1.74.4Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.42,112.45c-.58,0-1.18-.13-1.74-.4-1.99-.96-2.82-3.35-1.86-5.34l19.55-40.42c.96-1.99,3.35-2.82,5.34-1.86,1.99.96,2.82,3.35,1.86,5.34l-19.55,40.42c-.69,1.43-2.12,2.26-3.6,2.26Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,155.55c-2.21,0-4-1.79-4-4v-14.29c0-4.37-3.55-7.92-7.92-7.92h-14.57c-4.37,0-7.92,3.55-7.92,7.92v14.29c0,2.21-1.79,4-4,4s-4-1.79-4-4v-14.29c0-8.78,7.14-15.92,15.92-15.92h14.57c8.78,0,15.92,7.14,15.92,15.92v14.29c0,2.21-1.79,4-4,4Z",
    style: {
      fill: "#133c46"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessons);
export default __webpack_public_path__ + "static/media/lessons.cbb801a5c71378ce4fd248dc8f5ca5eb.svg";
export { ForwardRef as ReactComponent };